import { ApiClient } from '@/services/http/apiClient';
import type { LoginRequest, TokenResponse, MeResponse } from '@/types/api';

export const AuthService = {
  setToken(token: string | null) {
    ApiClient.setToken(token);
  },
  getToken() {
    return ApiClient.getToken();
  },

  async register(data: { name: string; email: string; password: string; password_confirmation?: string }) {
    return ApiClient.post<any>('/auth/register', { body: data });
  },

  async login(email: string, password: string): Promise<TokenResponse> {
    const payload: LoginRequest = { email, password };
    const res = await ApiClient.post<TokenResponse>('/auth/login', { body: payload });
    // Ao logar, o backend revoga tokens anteriores e retorna um novo token
    return res;
  },

  async logout() {
    return ApiClient.post<{ success: boolean; message?: string }>('/auth/logout');
  },

  async me(): Promise<MeResponse> {
    return ApiClient.get<MeResponse>('/auth/me');
  },

  async refresh(): Promise<TokenResponse> {
    return ApiClient.post<TokenResponse>('/auth/refresh');
  },

  async updateProfile(data: { name?: string; email?: string }) {
    return ApiClient.put<any>('/auth/profile', { body: data });
  },

  async changePassword(data: { current_password: string; password: string; password_confirmation?: string }) {
    return ApiClient.put<any>('/auth/password', { body: data });
  },

  async revokeAllTokens() {
    return ApiClient.post<{ success: boolean; message?: string }>('/auth/revoke-all');
  },
};